import React from "react";
import { UsersThree, Star, ShieldCheck } from "@phosphor-icons/react";
import StartLeadForm from "./StartLeadForm";
import StartMockup from "./StartMockup";
import StartShapes from "./StartShapes";
import { HERO, getProfessionContent } from "../../data/startPageContent";
import "./StartHero.css";

const TRUST_ICONS = { therapists: UsersThree, rating: Star, moh: ShieldCheck };

/**
 * Hero (plan §4.1): copy + form on the right (RTL first), mockup on the left.
 * Mobile order: overline → H1 → sub → form → trust → mockup.
 */
/**
 * Accent rendering: `*word*` segments become <em> (mint). Without markers,
 * falls back to "A. B" → B in mint. Plain titles stay plain.
 */
function AccentTitle({ text }) {
  if (text.includes("*")) {
    const parts = text.split("*");
    return parts.map((part, i) => (i % 2 === 1 ? <em key={i}>{part}</em> : <React.Fragment key={i}>{part}</React.Fragment>));
  }
  const idx = text.indexOf(". ");
  if (idx === -1) return text;
  return (
    <>
      {text.slice(0, idx + 1)} <em>{text.slice(idx + 2)}</em>
    </>
  );
}

export default function StartHero({ title, profession = null, utm = null }) {
  const content = getProfessionContent(profession);
  const sub = profession ? content.heroSub : HERO.sub;

  return (
    <section id="start-hero" className="st-section st-section--hero st-hero st-dark" aria-labelledby="st-h1">
      <StartShapes prefix="st-hero" />
      <div className="st-container st-hero-grid">
        <div className="st-hero-copy">
          <p className="st-overline st-rise st-rise--1">{HERO.overline}</p>
          <h1 id="st-h1" className="st-h1 st-rise st-rise--2"><AccentTitle text={title} /></h1>
          <p className="st-sub st-hero-sub st-rise st-rise--3" key={profession || "default"}>
            {sub}
          </p>

          <div className="st-hero-form st-rise st-rise--4">
            <StartLeadForm variant="hero" profession={profession} utm={utm} />
          </div>

          <ul className="st-hero-trust st-rise st-rise--5" aria-label="נתוני אמון">
            {HERO.trust.map((t) => {
              const Icon = TRUST_ICONS[t.key] || ShieldCheck;
              return (
                <li key={t.key}>
                  <Icon size={18} weight={t.key === "rating" ? "fill" : "regular"} />
                  <span>{t.text}</span>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="st-hero-visual st-rise st-rise--3">
          <StartMockup profession={profession} />
        </div>
      </div>
    </section>
  );
}
